import { useStaticData } from '@mc/static-data-react'
import type { Course } from '@mc/api'

import { CategoryBreadcrumbBar } from 'components/CategoryBreadcrumbBar'
import { PrimaryCategoryAndSubcategory } from 'libs/server/api/growth'

export const ClassCategoryBreadcrumbBar = ({
  hidePen4874,
}: {
  // with pen-4874_v1 we want to hide this component in the variant case,
  // because it is moved inside the hero component for pen-4874_v1
  // productization note: delete this prop
  hidePen4874?: boolean
}) => {
  const { course, primaryGrowthCatAndSubcat } = useStaticData<{
    course: Course
    primaryGrowthCatAndSubcat: PrimaryCategoryAndSubcategory
  }>()

  if (hidePen4874) return null

  if (!primaryGrowthCatAndSubcat) return <></>

  const { primaryCategory, primarySubcategory } = primaryGrowthCatAndSubcat

  return (
    <CategoryBreadcrumbBar
      course={course}
      category={primaryCategory}
      subcategory={primarySubcategory}
    />
  )
}
